// src/shared/components/Error.js
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <div className="container py-5" style={{ maxWidth: 700 }}>
      <div className="text-center">
        <h1 className="display-5 fw-bold text-danger mb-3">404</h1>
        <h3 className="mb-3">ไม่พบหน้าที่คุณต้องการ</h3>
        <p className="text-muted mb-4">
          อาจเป็นเพราะลิงก์หมดอายุ หรือเนื้อหาถูกลบไปแล้ว
        </p>

        <Link to="/" className="btn btn-primary btn-lg">
          ⟵ กลับสู่หน้าแรก
        </Link>
      </div>
    </div>
  );
}